import { Spinner, SpinnerSize } from '@amzn/atoz-native';
import { Metric } from '@amzn/showtime';
import React, { useEffect, useRef } from 'react';
import { getLocale, parseDataAttributes } from './dom';
import ShowtimeWebApp from './ShowtimeWebApp';
import { useStartupState } from './bootstrapping';
import ContextProviders from './providers';
import TENANT_ID from './TenantId';
export default function AtoZMobileWeb({ bootstrapFunctions, bundleVersion, devAuthToken, htmlDataAttributes, }) {
    const { appName, rootTag } = htmlDataAttributes;
    // This ref is used to pass react navigation functionality from AppNavigation up to ShowtimeApp
    const navigationRef = useRef(null);
    const locale = getLocale();
    const { providableUrls, userContext } = parseDataAttributes(rootTag.dataset, appName);
    const { employeeId, enabledFeatures } = userContext;
    const startupStateProps = {
        bootstrapFunctions,
        bootstrapProps: {
            employeeId,
            features: enabledFeatures,
        },
        bundleVersion,
        devAuthToken,
        employeeId,
        locale,
    };
    const { phase, data } = useStartupState(startupStateProps);
    useEffect(() => {
        if (phase === 'ready') {
            Metric('AppLaunch', TENANT_ID).put();
        }
        else if (phase === 'error') {
            Metric('AppLaunchError', TENANT_ID).put();
        }
    }, [phase]);
    if (phase !== 'ready' || !data) {
        return React.createElement(Spinner, { loadingText: "Loading...", size: SpinnerSize.Large });
    }
    const { placements } = data;
    return (React.createElement(ContextProviders, null,
        React.createElement(ShowtimeWebApp, { bundleVersion: bundleVersion, navigationRef: navigationRef, placements: placements, userContext: userContext, providableUrls: providableUrls })));
}
//# sourceMappingURL=AtoZMobileWeb.js.map